import { render, staticRenderFns } from "./UserBtnMenu.vue?vue&type=template&id=d45a9e50&"
import script from "./UserBtnMenu.vue?vue&type=script&lang=js&"
export * from "./UserBtnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports